import HomePage from "@/views/HomePage.vue";
import DemoPage from "@/views/demo/DemoPage.vue";

export default [
    // 홈 페이지 (로그인 페이지)
    {
        path: "/",
        name: "HomePage",
        component: HomePage,
    },
    // 데모 페이지
    {
        path: "/demo",
        name: "DemoPage",
        component: DemoPage,
    },
]